<template>
  <div>
    <!-- 메인 접수 대기자수 영역 -->
    <div class="alert_num">
      <div class="alert_num_title" aria-hidden="true">접수 대기자 수</div>
      <div class="alert_num_disc">
        <span
            role="button"
            ref="menuBtnCall"
            @click="getCallWaitCount"
            :aria-label="`접수 대기자 수는 ${wait_cnt}명 입니다.`"
            tabindex="0"
        >{{ wait_cnt }}명</span>
      </div>
    </div>
    <!--            role="button"-->
    <!--// 메인 접수 대기자수 영역 -->
    <!-- 메인 컨텐츠 영역 -->
    <article class="main_contents">
      <nav class="main_menu">
        <ul role="presentation">
          <li class="menu_btn_call" role="presentation" tabindex="1"
              @click="orderLink(3, 13)" ><a
              href="javascript:void(0);" role="button" aria-label="인터넷 콜접수 페이지로 이동" >인터넷 콜접수</a></li>
          <li class="menu_btn_method" role="presentation" tabindex="2"
               @click="doRegist()"><a
              href="javascript:void(0);" role="button" aria-label="신규가입 페이지로 이동">신규가입</a></li>
          <li class="menu_btn_target" role="presentation" tabindex="3"
               @click="subLink(2, 12)"><a
              href="javascript:void(0);" role="button" aria-label="이용안내 페이지로 이동">이용안내</a></li>
          <li class="menu_btn_status" role="presentation" tabindex="4"
               @click="subLink(1, 8)"><a
              href="javascript:void(0);" aria-label="운영현황 페이지로 이동">운영현황</a></li>
        </ul>
      </nav>
    </article>
  </div>
</template>

<script>
import callPreCheck from '../mixins/callPreCheck';

export default {
  data() {
    return {
      callInfo: null,
      wait_cnt: 0
    }
  },
  mounted() {
    this.$store.commit('setMenuNo', {'p_no': 0, 'category_no': 0});
    this.getCallWaitCount();

    // 페이지 로드 후 특정 요소로 포커스 이동
    this.$nextTick(() => {
      const menuBtnCall = this.$refs.menuBtnCall;
      if (menuBtnCall) {
        menuBtnCall.focus();
      }
    });
  },
  mixins: [callPreCheck],
  methods: {
    getCallWaitCount() {
      //alert('서비스 점검 중입니다.\n이용에 불편을 드려 죄송합니다.');

      this.$http.get('/api/order/callWait.do').then((response) => {
        if (response.data.retval == this.CONSTANT.SUCCESS) {
          this.wait_cnt = response.data.wait_cnt;
        }
      });
    },
    orderLink(p_no, category_no) {
      if (p_no === 3 && category_no === 13) {
        this.callPreCheckThen(
            () => {
              this.$store.commit('setMenuNo', {p_no, category_no});
              this.$router.push('/m/order/call');
            },
            (code) => {
              if (code === 'ALREADY_HAS_CALL') {
                this.$store.commit('setMenuNo', {p_no: 3, category_no: 15});
                this.$router.push('/m/order/progress');
                return true;
              }
              return false;
            }
        );
        return;
      }
      this.$store.commit('setMenuNo', {p_no, category_no});
      this.$router.push('/m/order/call');
    },
    subLink(p_no, category_no) {
      this.$store.commit('setMenuNo', {'p_no': p_no, 'category_no': category_no});
      this.$router.push('/m/sub/' + category_no);
    },
    doRegist() {
      this.$router.push('/m/member/registClass')
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/Main.vue